import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const TabContainer = styled.div`
    margin: 0 0 0 0px;
`;

export const Title = styled.div`
    font-family: AvenirNextWorld demi;
    color: #202124;
    font-size: 14px;
    margin-bottom: 8px;

    &:after {
        content: '${(props) => (props.showAstrisk ? '*' : '')}';
        color: red;
        padding-left: 3px;
    }
`;

export const TextAreaContainer = styled.div`
    margin: 0px;
    ${media.mobileDevice`
     margin: 0px;
    `}
`;

export const TextArea = styled.textarea`
    resize: none;
    width: 100%;
    height: ${({ height }) => (height ? height : '330px')};
    margin-top: 0px;
    background: #ffffff 0% 0% no-repeat padding-box;
    border: 2px solid #ebeded;
    border-radius: 6px;
    font-family: 'AvenirNextWorld Regular';
    letter-spacing: -0.11px;
    font-size: 14px;
    padding: 10px 10px 0 10px;
    &::-webkit-input-placeholder {
    }
    &:focus {
        outline: none !important;
    }
    ${media.mobileDevice`
     height: 182px;
    `}
`;

export const StyledDiv = styled.div`
    width: 100%;
    height: 25px;
    margin: 0 0 0 0px;
    ${media.mobileDevice`
    display:none;
`}
`;

export const ButtonsContainer = styled.div`
    margin-top: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 30px;
    ${media.mobileDevice`
     justify-content: space-between;
     margin-top: 30px;
    `}
`;
